import { Component, OnInit } from '@angular/core';
import {UtilService} from "../../services/utilService/util.service";
import {SuperAdminService} from "../../services/apiCalls/superAdminService/super-admin.service";
import { environment as ENV } from '../../../environments/environment';
import {IResponse} from "../../interfaces/iresponse";
import {UserService} from "../../services/apiCalls/userService/user.service";
import {BootstrapNotifyService} from "../../services/bootstrap-notify/bootstrap-notify.service";

@Component({
  selector: 'app-agents',
  templateUrl: './agents.component.html',
  styleUrls: ['./agents.component.css']
})
export class AgentsComponent implements OnInit {
  breadCrumb: any;
  public EMAIL_VALIDATION: any =  ENV.EMAIL_VALIDATION;
  loaders = {
    saving: false
  };
  allStates: any[] = [];
  allLGA: any[] = [];
  superAgents: any[] = [];
  filterArray: any[] = [];
  filterStatusArray: any[] = [];
  activeAgent = null;
  agent =  {
    first_name: null,
    last_name: null,
    email: null,
    phone_no: null,
    lga_id: null,
    state_id: null,
    super_agent_code: null,
    password: 'password',
    password_confirmation: 'password'
  };
  stateHolder = null;
  loadingData = false;
  disabled: boolean = false;
  agentId: Number = 0;
  stateSelected = false;
  changeOccured = true;
  public allAgents: any[] = [];
  public pagination = {
  currentPage: 1,
  lastPage: 1,
  perPage: 20,
  total: 0,
  from: 0,
  to: 0
};
  public modal = {
    title: 'Create Agent',
    btnText: 'SAVE'
  };
  public filter = {filterByStatus: null, filterBySuperAgent: null};
  constructor(private utilService: UtilService,
              private userService: UserService,
              private bootstrapNotify: BootstrapNotifyService,
              private superAdminService: SuperAdminService) {
    this.getStates();
    this.getSuperAgents();
  }

  ngOnInit() {
    this.breadCrumb  = {
      name: 'Agents',
      parent: 'Home',
      subLink: null
    };
    this.getAllAgents();
    this.filterStatusArray = [{id: 1, name: 'Approved'}, {id: 0, name: 'Awaiting Approval'}]
  }

  openDialog(id) {
  this.modal = {
      title: 'Create Agent',
      btnText: 'SAVE'
    };
    this.activeAgent = null;
    this.resetForm();
    this.utilService.openModal(id);
  }
  getAllAgents() {
    this.loadingData = true;
    this.changeOccured = false;
    this.superAdminService.getAllAgents(this.pagination.currentPage, this.pagination.perPage)
      .subscribe((res: IResponse) => {
        this.allAgents = res.data.data;
        this.pagination = {
          currentPage: res.data.current_page,
          lastPage: res.data.last_page,
          perPage: res.data.per_page,
          total: res.data.total,
          from: res.data.from,
          to: res.data.to
        };
        this.utilService.startDatatable('agents-list');
        this.loadingData = false;
        this.changeOccured = true;
      }, error => {
        this.utilService.startDatatable('agents-list');
        this.loadingData = false;
        this.changeOccured = true;
      });
  }

  public toggleAgentStatus(agent){
    this.disabled = true;
    this.agentId = agent?.id;

    const action = agent.status === 'Active' ? 'disable' : 'enable';

    this.utilService.confirmAction(() => {
      this.superAdminService.toggleAgentStatus(agent.id, action).subscribe((res: IResponse) => {
        this.resetStatusFilter();
        this.getAllAgents();
        this.bootstrapNotify.success(res.message || `Agent ${action}d successfully!`, 'right');
      }, error => {
        this.bootstrapNotify.error(error.error.message);
      }).add(() => this.disabled = false);
    }, () => {
      this.agentId = 0;
      this.disabled = false;
    });
  }

  private resetStatusFilter() {
    this.filter.filterByStatus = null;
  } 

  public deleteAgent(agent) {
    this.utilService.confirmAction(() => {
      this.superAdminService.deleteAgent(agent.id)
        .subscribe((res: IResponse) => {
          this.bootstrapNotify.success(res.message);
          this.getAllAgents();
        }, error => {
          this.bootstrapNotify.error(error.error.message);
        });
    })
  }
  public triggerEdit(agent){
    this.activeAgent = JSON.parse(JSON.stringify(agent));
    // this.agent.super_agent_code = this.activeAgent.unique_code.
    this.resetForm();
    this.utilService.openModal('createAgent');
    this.agent = this.activeAgent;
    this.agent.lga_id = this.activeAgent.lga.id;
    this.agent.state_id = this.activeAgent.state.id;
    this.agent.super_agent_code = this.activeAgent.super_agent.unique_code;
    const allLGA = this.allStates.filter(state => state.id === this.agent.state_id);
    this.allLGA = allLGA[0].lgas;
    this.stateSelected = true;
    this.modal = {
      title: 'Update Agent',
      btnText: 'UPDATE'
    };
  }

  public getStates() {
    this.userService.getAllState().subscribe(res => {
      this.allStates = res.data;
    }, error => {
    });
  }
  public filterLGA(e) {
    this.stateSelected = false;
    this.agent.lga_id = null;
    setTimeout(() => {
      this.stateSelected = true;
    }, 200);
    this.allLGA = e.lgas;
  }
  public getSuperAgents() {
    this.superAdminService.getAllSuperAgents('', this.pagination.currentPage, this.pagination.perPage)
      .subscribe((res: IResponse) => {
        this.superAgents = res.data.data;
        this.filterArray = [{full_name: 'All', id: -99, unique_code: 'All'}, ...this.superAgents];
      }, error => {
      });
  }

  public createNewAgent() {
    this.loaders.saving = true;
    if (!this.agent.email) {
      this.bootstrapNotify.info('Agent Email is Required');
      this.loaders.saving = false;
    } else if (!this.agent.phone_no) {
      this.bootstrapNotify.info('Agent Phone Number is Required');
      this.loaders.saving = false;
    } else if (!this.agent.first_name) {
      this.bootstrapNotify.info('Agent First Name is Required');
      this.loaders.saving = false;
    } else if (!this.agent.last_name) {
      this.bootstrapNotify.info('Agent Last Name is Required');
      this.loaders.saving = false;
    } else if (!this.agent.password && !this.activeAgent) {
      this.bootstrapNotify.info('Enter a secure password');
      this.loaders.saving = false;
    }  else if (this.agent.password !== this.agent.password_confirmation  && !this.activeAgent) {
      this.bootstrapNotify.info('Password must match!');
      this.loaders.saving = false;
    } else if (!this.agent.lga_id || this.agent.lga_id === 'undefined') {
      this.bootstrapNotify.info('Select your local government!');
      this.loaders.saving = false;
    } else {
      if(this.activeAgent) {
        this.updateAgent();
      } else {
        this.superAdminService.createAgent(this.agent).subscribe((response: IResponse) => {
          this.loaders.saving = false;
          this.resetForm();
          this.getAllAgents();
          this.utilService.closeModal('createAgent');
          this.bootstrapNotify.info(response.message || 'Agent created successfully!');
        }, error => {
          this.bootstrapNotify.error(error.error.message || 'Unable to create agent!', 'right');
          this.loaders.saving = false;
        });
      }
      }

  }
  public updateAgent() {
    delete this.agent.password_confirmation;
    delete this.agent.password;
    delete this.activeAgent.status;
    this.superAdminService.updateAgent(this.activeAgent, this.activeAgent.id).subscribe((response: IResponse) => {
      this.loaders.saving = false;
      this.resetForm();
      this.getAllAgents();
      this.utilService.closeModal('createAgent');
      this.bootstrapNotify.info(response.message || 'Agent updated successfully!');
    }, error => {
      this.bootstrapNotify.error(error.error.message || 'Unable to update agent!', 'right');
      this.loaders.saving = false;
    });
  }
  public resetForm() {
    this.agent =  {
      first_name: null,
      last_name: null,
      email: null,
      phone_no: null,
      lga_id: null,
      state_id: null,
      super_agent_code: null,
      password: 'password',
      password_confirmation: 'password'
    };
    this.stateHolder = null;
  }
  public getAgents(e, statusFilter=false) {

    if(!e || e.unique_code === 'All') {
      this.getAllAgents();
      return false;
    }
    this.changeOccured = false;
    this.loadingData = true;
    const filterObj: any = {};
    if(statusFilter) {
      filterObj.approved = this.filter.filterByStatus;
    }

    this.superAdminService.getSuperAgentAgent(filterObj, this.filter.filterBySuperAgent)
      .subscribe((res: IResponse) => {
      this.changeOccured = true;
        this.allAgents = res.data;
        this.utilService.startDatatable('agents-list');
        this.loadingData = false;
        // this.filter.filterBySuperAgent = null;
        setTimeout(() => {
      this.filter.filterByStatus = null
    }, 2000);
      }, error => {
        this.utilService.startDatatable('agents-list');
        this.loadingData = false;
        this.changeOccured = true;
        // this.filter.filterBySuperAgent = null;
      });
  }
  public showMyAgents(sAgent) {
    this.changeOccured = false;
    this.loadingData = true;
    this.superAdminService.getSuperAgentAgent({}, sAgent.id)
      .subscribe((res: IResponse) => {
        this.changeOccured = true;
        this.allAgents = res.data.data;
        this.utilService.startDatatable('agents-list');
        this.loadingData = false;
        // this.filter.filterBySuperAgent = null;
      }, error => {
        this.utilService.startDatatable('agents-list');
        this.loadingData = false;
        this.changeOccured = true;
        // this.filter.filterBySuperAgent = null;
      });
  }

}
